module.exports = __webpack_public_path__ + "static/fonts/Montserrat200italic.f9ab30a6.ttf";